// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; // ✅ NEW

// Use your project values
const firebaseConfig = {
  apiKey: "AIzaSyCTkWJItfgCjCv-9pNvTsD9hN-yelYvOug",
  authDomain: "isanails-7efe9.firebaseapp.com",
  projectId: "isanails-7efe9",
  // IMPORTANT: use the canonical storage bucket host
  storageBucket: "isanails-7efe9.appspot.com",
  messagingSenderId: "935035776190",
  appId: "1:935035776190:web:ba8bab5f31d947a27082ef",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Auth, Firestore, Storage, and Functions
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// ✅ Add this default export so you can `import app from "../firebase";`
export default app;
